import { Image, Button } from "react-bootstrap"

const FishLoader = (({ topic, level, cancel }) => {
    const gifs = [
        {
            name: 'fish',
            src: 'https://i.imgur.com/cXi1P3B.gif',
            alt: 'Fish gif',
        },
        {
            name: 'chicks at week 6',
            src: 'https://i.imgur.com/TPMtCw9.gif',
            alt: 'Chicks at 6 weeks old',
        },
        {
            name: 'cleaning rocks',
            src: 'https://i.imgur.com/k08MdQf.gif',
            alt: 'Cleaning rocks',
        },
        {
            name: 'cinnamon raisin bread',
            src: 'https://i.imgur.com/PEj9uVD.gif',
            alt: 'Baking cinnamon raisin bread',
        },
    ]
    const index = Math.floor(Math.random() * gifs.length);

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h4>{`Quiz on ${topic} at the ${level} level will be generated in a jiffy. While you wait, check out this sweet ${gifs[index].name} gif`}</h4>
                <Image src={gifs[index].src} alt={gifs[index].alt} fluid/>

                {cancel && 
                <Button
                    className="my-2"
                    onClick={() => cancel()}
                >
                    Cancel
                </Button>}
            </div>
        </div>
    )
})

export default FishLoader